import script from "./ContentLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ContentLayout.vue?vue&type=style&index=0&id=2ac45c08&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac45c08"]])

export default __exports__